import { render, staticRenderFns } from "./CategoryFollowupRuleDialog.vue?vue&type=template&id=087ade98&scoped=true&"
import script from "./CategoryFollowupRuleDialog.vue?vue&type=script&lang=js&"
export * from "./CategoryFollowupRuleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087ade98",
  null
  
)

export default component.exports